module.exports = __webpack_public_path__ + "static/media/Rainfall_Annoyed.6ec4e3f1.gif";